const stageKeys = {
  base: () => 
    ['stage'] as const,
  getStageListForEvent: (eventId: string) =>
    [stageKeys.base, eventId, 'get_stage_list_for_event'] as const
}

export default stageKeys